import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onClick"];
import styled from 'styled-components';
import I18n from 'I18n';
import KnowledgePopoverEmptyState from './draft-content-transplant-ka/KnowledgePopoverEmptyState';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Typeahead } from 'foundations-components/transitional/components/Typeahead';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoadingSpinnerContainer = () => {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    justifyContent: "center",
    blockSize: "180px",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {})
  });
};
const StyledKBResultItem = styled.li.withConfig({
  displayName: "MultiKBTypeaheadContainer__StyledKBResultItem"
})(["display:flex;align-items:center;*:first-child{flex:4;text-align:left;}button{flex:1;}"]);
const KBResultItem = _ref => {
  let {
      children,
      // @ts-ignore - onClick is not a valid prop for TypeaheadResultsItemProps['itemComponent'] - Typeahead prop types are more strict than UITypeahead - I also don't see onClick being used in Typeahead, but leaving here for posterity
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(StyledKBResultItem, Object.assign({}, rest, {
    onClickCapture: onClick,
    "data-test-id": "kb-result-item",
    children: [children, /*#__PURE__*/_jsx(IconButton, {
      use: "transparent",
      children: /*#__PURE__*/_jsx(RightIcon, {
        size: "200"
      })
    })]
  }));
};
const MultiKBTypeaheadContainer = ({
  onChange,
  onSearchChange,
  portalId,
  kbsAreLoading,
  options,
  searchQuery,
  searchIsLoading
}) => {
  if (kbsAreLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinnerContainer, {});
  }
  if (!kbsAreLoading && searchQuery.length === 0 && options.length === 0) {
    return /*#__PURE__*/_jsx(KnowledgePopoverEmptyState, {
      portalId: portalId
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Typeahead, {
      autoFilter: false,
      hideResults: searchIsLoading,
      itemComponent: searchQuery.length === 0 ? KBResultItem : undefined,
      options: options,
      onChange: onChange,
      onSearchChange: onSearchChange,
      placeholder: I18n.text('hubspot-prosemirror.knowledgeBase.search.placeholder')
    }), searchIsLoading && /*#__PURE__*/_jsx(LoadingSpinnerContainer, {})]
  });
};
export default MultiKBTypeaheadContainer;